import "rxjs/add/operator/toPromise";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Api, Settings } from "../providers";
import { Observable } from "rxjs";

declare var Stripe;

@Injectable()
export class StripeManager {
  private _stripe: any;

  constructor(public api: Api, public settings: Settings) {
    this._stripe = Stripe(environment.servicesConfig.stripe.publishableKey);
  }

  checkout(voucherId: string) {
    return Observable.create((observer) => {
      let tokenSeq = Observable.fromPromise(this.settings.getValue("token"));

      tokenSeq.subscribe((token) => {
        if (token) {
          let seq = this.api
            .post(
              environment.endPoints.stripe.checkout,
              { voucherId },
              {
                headers: {
                  Authorization: "Bearer " + token,
                },
              }
            )
            .share();

          seq.subscribe(
            (res: any) => {
              this._stripe.redirectToCheckout({ sessionId: res.data.id });
              observer.next(res);
            },
            (err) => {
              console.error("ERROR", err);
              observer.error(err.error);
            }
          );
        } else {
          observer.error();
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/managers/stripe.manager.ts